/**
 * EmptyState Component
 * 
 * Displays when there are no messages in the chat.
 * Shows welcome message and suggested topics based on mode.
 */

import type { ChatMode } from './ChatHeader';
import chatbotBgImage from '/src/assets/chatbot_bg_image.png';
import recommenderImage from '/src/assets/recommenderImage1.webp';

interface EmptyStateProps {
  mode: ChatMode;
}

export function EmptyState({ mode }: EmptyStateProps) {
  const isChatbot = mode === 'chatbot';

  const title = isChatbot 
    ? 'Hola, soy CeL.ia' 
    : '¡Encontremos tu curso ideal!';

  const description = isChatbot
    ? 'Tu asistente virtual de la UTN. Pregúntame sobre cursos, inscripciones o cualquier duda.'
    : 'Contame sobre tus intereses, experiencia y áreas donde querés crecer.';

  const tags = isChatbot
    ? ['Cursos', 'Inscripciones', 'Info General']
    : ['Tecnología', 'Diseño', 'Negocios'];

  const imageSrc = isChatbot ? chatbotBgImage : recommenderImage;

  const imageSize = isChatbot ? 'w-48 h-48' : 'w-36 h-36'; // Chatbot vs Recommender
  const imageMargin = isChatbot ? 'mb-3' : 'mb-6'; // Margen inferior para cada modo

  return (
    <div className=" h-full flex flex-col items-center justify-center text-center px-4 animate-in fade-in-50 duration-500">
      <div className={imageMargin}>
        <img 
          src={imageSrc} 
          alt={title} 
          className={`${imageSize} object-contain`}
        />
      </div>
      
      <h3 className="text-2xl font-bold text-foreground mb-2">
        {title}
      </h3>
      
      <p className="text-sm text-muted-foreground mb-6 max-w-[300px] leading-relaxed">
        {description}
      </p>
      
      <div className="flex flex-wrap gap-2 justify-center">
        {tags.map((tag) => (
          <span 
            key={tag} 
            className="px-3 py-1.5 bg-card rounded-full text-xs text-muted-foreground shadow-sm border"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}

